<ion-header class="ion-no-border">
  <ion-toolbar class="ion-no-padding">
    <ion-img slot="start" [alt]="logoAltName" [src]="logo" (click)="goHome()"></ion-img>
  </ion-toolbar>
</ion-header>
